import { ComponentProps } from "react";

import { CompanyLogo } from "@components/CompanyLogo/CompanyLogo";

import { Box } from "@design-system/Box/Box";
import { Skeleton } from "@design-system/Skeleton/Skeleton";
import { Text } from "@design-system/Text/Text";

type Props = {
  name?: string;
  subtext?: string;
  signedLogoUrl?: string;
  skipLogo?: boolean;
  domain?: string;
  weight?: ComponentProps<typeof Text>["weight"];
};

export const Resource = ({
  name,
  signedLogoUrl,
  subtext,
  domain = undefined,
  skipLogo = false,
  weight = 600,
}: Props) => {
  return (
    <Box gap={8} align="center">
      {skipLogo ? null : (
        <CompanyLogo size="sm" signedLogoUrl={signedLogoUrl} domain={domain} />
      )}
      <Box direction="column" gap={0}>
        <Text weight={weight} truncate maxWidth={250}>
          {name ?? <Skeleton width={150} />}
        </Text>
        {subtext ? (
          <Text truncate size={10} maxWidth={250}>
            {subtext}
          </Text>
        ) : null}
      </Box>
    </Box>
  );
};
